import logo from './logo.svg';
import './App.css';
import Header from './Components/Header';
import Menu from './Components/Menu';
import Content from './Components/Content';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Menu/>
      <Content />
      <Footer />
    </div>
  );
}

export default App;
